/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { GuestSpace } from "./GuestSpace";
export const GuestConfigUpdate = core.serialization.object({
    environmentId: EnvironmentId.optional(),
    email: core.serialization.string().optional(),
    name: core.serialization.string().optional(),
    spaces: core.serialization.list(GuestSpace).optional(),
});
